import { AdminPageCabecalhoComponent } from '../../shared/admin-page-cabecalho/admin-page-cabecalho.component';
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { Permissao, PermissoesApiService } from '@cei-ufg/ngx-cei-seguranca';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { CeiButtonComponent, CeiInputTextComponent, CeiPanelComponent, CeiSnackBarService } from '@cei-ufg/ngx-arquitetura-cei-frontend';
import { notifyAdminFormError, notifyAdminFormSuccess, stopIfAdminFormInvalid } from '../../shared/admin-form.utils';

@Component({
  selector: 'cei-admin-permissao-edit',
  standalone: true,
  imports: [AdminPageCabecalhoComponent, CommonModule, FormsModule, RouterModule, CeiInputTextComponent, CeiButtonComponent, CeiPanelComponent],
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class AdminPermissaoEditComponent {
  form: Partial<Permissao> = { name: '', codename: '' };
  permissoesApi = inject(PermissoesApiService);
  route = inject(ActivatedRoute);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly snackBar = inject(CeiSnackBarService);

  get registroId(): number {
    return Number(this.route.snapshot.paramMap.get('id'));
  }

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (id) {
      this.permissoesApi.permissaoRetrieve({ id }).subscribe(data => {
        this.form = { ...data };
        this.cdr.markForCheck();
      });
    }
  }

  onSubmit(form: NgForm) {
    if (stopIfAdminFormInvalid(form)) {
      this.cdr.markForCheck();
      return;
    }

    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (id) {
      this.permissoesApi.permissaoUpdate({ id, permissao: this.form as Permissao }).subscribe({
        next: () => {
          notifyAdminFormSuccess(this.snackBar, 'Permissão atualizada com sucesso!');
        },
        error: (err) => {
          notifyAdminFormError(this.snackBar, 'Erro ao atualizar permissão.', err);
        }
      });
    }
  }
}
